import { render, staticRenderFns } from "./_data.vue?vue&type=template&id=54d4f040&scoped=true&"
import script from "./_data.vue?vue&type=script&lang=js&"
export * from "./_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d4f040",
  null
  
)

export default component.exports